import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CustomButton, CustomIconButton, icon, IconComponent } from "..";
import { Flags, hasPermission, isFeatureEnabled, Permissions, translate } from "../../providers";
import { setCautionBannerDisabled, setCautionBannerHidden } from "../../slice";
import styles from "./QuotaLimitBanner.module.css";
import { useApi } from "../../hooks";
import { AiCompanyTokenQuotaService } from "../../../api";
import { roundTo } from "../../utils";

export default function QuotaLimitBanner({ onOpenAiConsumption }) {
	const { call: getAllQuotasConsumptions } = useApi(AiCompanyTokenQuotaService.getAllQuotasConsumptions);
	const { cautionBannerDisabled, loadingFlags, companyName } = useSelector(({ context }) => ({
		cautionBannerDisabled: context.cautionBannerHidden,
		loadingFlags: context.loadingFlags,
		companyName: context.company?.name,
	}));
	const [consumptionPercentage, setConsumptionPercentage] = useState(0);
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(setCautionBannerHidden(cautionBannerDisabled || consumptionPercentage < 80));
	}, [dispatch, cautionBannerDisabled, consumptionPercentage]);
	useEffect(() => {
		if (
			companyName &&
			!loadingFlags &&
			!hasPermission(Permissions.PLATFORM_ADMIN) &&
			isFeatureEnabled(Flags.AI_QUOTA)
		) {
			getAllQuotasConsumptions()
				.then((data) => {
					let maxPercentage = 0;
					data.forEach((d) => {
						const newPercentage = roundTo((d.consumed / d.totalLimit) * 100, 0);
						if (newPercentage > maxPercentage) {
							maxPercentage = newPercentage;
						}
					});
					setConsumptionPercentage(maxPercentage);
				})
				.catch(console.error);
		}
	}, [companyName, getAllQuotasConsumptions, loadingFlags, dispatch, cautionBannerDisabled]);
	const disableBanner = () => {
		dispatch(setCautionBannerDisabled(true));
	};
	const handleClick = () => {
		onOpenAiConsumption();
	};
	return (
		(!cautionBannerDisabled && consumptionPercentage >= 80 && (
			<header className={styles.container}>
				<div className={styles.leftSide}>
					<IconComponent
						className={styles.icon}
						color="var(--color-black)"
						icon={icon.faWandMagicSparkles}
						size="sm"
					/>
					<div>
						<div className={styles.text}>
							{translate(
								(consumptionPercentage >= 100 &&
									"common:components.caution-banner.quota-limit.description.over-limit") ||
									"common:components.caution-banner.quota-limit.description.near-limit",
								{ percentage: consumptionPercentage }
							)}
						</div>
						<CustomButton className={styles.configureButton} onClick={handleClick}>
							{translate("common:components.caution-banner.quota-limit.button")}
						</CustomButton>
					</div>
				</div>
				<span>
					<CustomIconButton icon={icon.faTimes} size="sm" onClick={disableBanner} />
				</span>
			</header>
		)) ||
		null
	);
}
